export default [
  {
    path: '/landings',
    name: 'landings',
    component: () => import('@/views/menu/landing/landings.vue'),
    meta: {
      pageTitle: 'مدیریت لندینگ ها',
      action: 'show',
      resource: 'BlogManager',
    },
  },
  {
    path: '/landings/add',
    name: 'addLanding',
    component: () => import('@/views/menu/landing/landingItem.vue'),
    meta: {
      pageTitle: 'ایجاد لندینگ جدید',
      action: 'show',
      resource: 'BlogManager',
    },
  },
  {
    path: '/landings/edit/:id',
    name: 'updateLanding',
    component: () => import('@/views/menu/landing/landingItem.vue'),
    meta: {
      pageTitle: 'ویرایش لندینگ',
      action: 'show',
      resource: 'BlogManager',
    },
  },
]